import { OctagonX } from 'lucide-react';

import { EventLine } from '@apps/web/features/phoebe_chat_v3/ui/primitives/event_line';
import { useViewerUserId } from '@apps/web/features/phoebe_chat_v3/ui/viewer_user_context';

export const VIEWER_STOP_REQUEST_COPY = 'You asked Phoebe to stop.';
export const UNATTRIBUTED_STOP_REQUEST_COPY = 'Phoebe was asked to stop.';

type StopRequestLineProps = Readonly<{
    readonly userId: string | null;
    readonly displayName: string | null;
}>;

// The viewer's own stop always reads "You", even after the committed event
// names them — re-rendering their own action in the third person is a
// visible flicker with no information gained. A collaborator's stop is
// named once the committed event carries their name, and stays unattributed
// while only the pending enqueue is known.
export function StopRequestLine({ userId, displayName }: StopRequestLineProps) {
    const viewerUserId = useViewerUserId();
    const copy =
        userId !== null && userId === viewerUserId
            ? VIEWER_STOP_REQUEST_COPY
            : displayName !== null
              ? `${displayName} asked Phoebe to stop.`
              : UNATTRIBUTED_STOP_REQUEST_COPY;
    return <EventLine glyph={<OctagonX />}>{copy}</EventLine>;
}
